<template>

	<form class="row margin-b-100 order" @submit.prevent="submitInformation">

		<header class="col-7 margin-b-50 padding-b-50 border-b">

			<h1>Dine oplysninger</h1>

			<p>Udfyld dine adresse oplysninger, e-mail adresse og telefonnummer.</p>

		</header>

		<section class="col-7 margin-b-75 padding-b-75 border-b">

			<section class="row">

				<section class="col-12 margin-b-75">

					<label>Hvad er dit fornavn?</label>

					<section class="input-group">

						<input class="col-12" type="text" placeholder="F.eks. søren" name="firstname" v-model="information.firstname" @blur="enteredField('firstname')">

						<span class="checkmark-order" v-if="firstNameValidated">

                            <i class="icon--sm green fas fa-check-circle"></i>

						</span>

						<span class="checkmark-order" v-if="!firstNameValidated && hasEnteredFirstName">

                            <i class="icon--sm red fas fa-check-circle"></i>

						</span>

					</section>

				</section>

				<section class="col-12 margin-b-75">

					<label>Hvad er dit efternavn?</label>

					<section class="input-group">

						<input class="col-12" type="text" placeholder="F.eks. Hansen" name="lastname" v-model="information.lastname" @blur="enteredField('lastname')">

						<span class="checkmark-order" v-if="lastNameValidated">

                              <i class="icon--sm green fas fa-check-circle"></i>

                            </span>

						<span class="checkmark-order" v-if="!lastNameValidated && hasEnteredLastName">

                              <i class="icon--sm red fas fa-check-circle"></i>

						</span>

					</section>

				</section>

			</section>

			<section class="row margin-b-75">

				<label>Hvad er din adresse?</label>

				<section class="input-group">

					<input class="col-12" type="text" placeholder="F.eks. Kanalvej 52" name="address" v-model="information.address" @blur="enteredField('address')">

					 <span class="checkmark-order" v-if="addressValidated">

						 <i class="icon--sm green fas fa-check-circle"></i>

					 </span>

					<span class="checkmark-order" v-if="!addressValidated && hasEnteredAddress">

						<i class="icon--sm red fas fa-check-circle"></i>

					</span>

				</section>

			</section>

			<section class="row">

				<section class="col-12 margin-b-75">

					<label>Hvad er dit postnummer?</label>

					<section class="input-group">

						<input class="col-12" type="tel" placeholder="F.eks. 5000" name="zipcode" id="zipcode" min="1000" max="9999" maxlength="4" v-model="information.zipcode" @blur="enteredField('zip')">

						<span class="checkmark-order" v-if="zipCodeValidated">

							<i class="icon--sm green fas fa-check-circle"></i>

						</span>

						<span class="checkmark-order" v-if="!zipCodeValidated && hasEnteredZip">

							<i class="icon--sm red fas fa-check-circle"></i>

						</span>

					</section>

				</section>

				<section class="col-12 margin-b-75">

					<label>Hvilken by bor du i?</label>

					<section class="input-group">

						<input class="col-12" type="text" placeholder="F.eks. Odense c" name="city" v-model="information.city" @blur="enteredField('city')">

						<span class="checkmark-order" v-if="cityValidated">

							<i class="icon--sm green fas fa-check-circle"></i>

						</span>

						<span class="checkmark-order" v-if="!cityValidated && hasEnteredCity">

							<i class="icon--sm red fas fa-check-circle"></i>

						</span>

					</section>

				</section>

			</section>

			<section class="row">

				<section class="col-12 margin-b-75">

					<label>Hvad er din e-mail adresse?</label>

					<section class="input-group">

						<input class="col-12" type="email" placeholder="F.eks. ole@hansen.dk"  name="email" v-model="information.email" @blur="enteredField('email')">

						<span class="checkmark-order" v-if="emailValidated">

							<i class="icon--sm green fas fa-check-circle"></i>

						</span>

						<span class="checkmark-order" v-if="!emailValidated && hasEnteredEmail">

							<i class="icon--sm red fas fa-check-circle"></i>

						</span>

					</section>

				</section>

				<section class="col-12 margin-b-75">

					<label>Hvad er dit telefonummer?</label>

					<section class="input-group">

						<input class="col-12" type="number" placeholder="F.eks. 62717181" name="phone" v-model="information.phone" @blur="enteredField('phone')">

						<span class="checkmark-order" v-if="phoneValidated">

							<i class="icon--sm green fas fa-check-circle"></i>

						</span>

						<span class="checkmark-order" v-if="!phoneValidated && hasEnteredPhone">

							<i class="icon--sm red fas fa-check-circle"></i>

						</span>

					</section>

				</section>

			</section>

			<section class="row">

				<section class="col-12 margin-b-75">

					<label>Hvad er dit firmanavn? (valgfrit)</label>

					<section class="input-group">

						<input class="col-12" type="text" placeholder="F.eks Firma ApS (valgfrit)"  name="company_name" v-model="information.company_name" @blur="enteredField('company_name')">

						<span class="checkmark-order" v-if="companyAndCvrValidated">

							<i class="icon--sm green fas fa-check-circle"></i>

						</span>

						<span class="checkmark-order" v-if="!companyAndCvrValidated">

							<i class="icon--sm red fas fa-check-circle"></i>

						</span>

					</section>

				</section>

				<section class="col-12 margin-b-75">

					<label>Hvad er dit CVR-nummer? (valgfrit)</label>

					<section class="input-group">

						<input class="col-12" type="number" placeholder="F.eks. 62717181 (valgfrit)" name="cvr" v-model="information.cvr" @blur="enteredField('cvr')">

						<span class="checkmark-order" v-if="companyAndCvrValidated">

							<i class="icon--sm green fas fa-check-circle"></i>

						</span>

						<span class="checkmark-order" v-if="!companyAndCvrValidated">

							<i class="icon--sm red fas fa-check-circle"></i>

						</span>

					</section>

				</section>

                <section class="col-12 margin-b-75">

                    <label>Hvad er dit EAN-nummer? (valgfrit)</label>

                    <section class="input-group">

                        <input class="col-12" type="number" placeholder="f.eks. 1234567890123 (valgfrit)" name="ean" v-model="information.ean" @blur="enteredField('ean')">

                        <span class="checkmark-order" v-if="eanValidated">

							<i class="icon--sm green fas fa-check-circle"></i>

						</span>

                        <span class="checkmark-order" v-else>

							<i class="icon--sm red fas fa-check-circle"></i>

						</span>

                    </section>

                </section>

			</section>

			<section class="row">

				<header class="header margin-b-50">

					<h1>Bemærkninger til ordren</h1>

					<p>Der kan <strong>IKKE</strong> ændres i menuerne, ej heller i forhold til allergier.</p>

					<p>Ved ekstra køb til eksisterende ordre skriv ordrenr. nedenfor.</p>

				</header>

				<section class="col-12">

					<textarea class="col-12" placeholder="F.eks. tilkøb til en eksisterende ordre" name="notes" v-model="information.notes"></textarea>

				</section>

			</section>

		</section>

		<section class="col-7 flex--space">

            <router-link :to="{name:backRoute}">Tilbage</router-link>

			<button type="submit" class="btn--primary btn--sm primary--copper" :class="{'disabled':(!allInformationValidated || isLoading)}" :disabled="isLoading && !allInformationValidated" dusk="information-done">
				<span v-if="isLoading">
					<i class="spinner--light" v-if="isLoading"></i>
					Bearbejder
				</span>
				<span v-else>
					Gå til Levering
				</span>
			</button>

		</section>
	</form>
</template>

<script>
	import {mapGetters} from 'vuex';
	import fetchCityByZip from './../mixins/fetchCityByZip.js';
    export default {
        name: "information",
		data(){
          	return {
                enteredFields: [],
                city: '',
                isLoading: false,
                backRoute:'make-order.order.summary',
			};
		},
		mixins:[fetchCityByZip],
		watch:{
			information:{
			    handler(value){
                    this.$store.dispatch('setInformation', value);
				},
				deep:true,
			},
		},
		computed:{
			...mapGetters({
				order:'order',
			}),
			information:{
                cache: false,
			    get(){
			        return this.order.information;
				},
				set(value){
			        this.$store.dispatch('setInformation', value);
				}
			},
            firstNameValidated() {
                if (this.information.firstname) {
                    return this.information.firstname !== '' && this.information.firstname.length > 0;
                }

                return false;
            },
            lastNameValidated() {
                if (this.information.lastname) {
                    return this.information.lastname !== '' && this.information.lastname.length > 0;
                }

                return false;
            },
            addressValidated() {
                if (this.information.address) {
                    var addressRegex = this.information.address.match(/([A-Z])\w*\s+([0-9])+/gi);

                    return this.information.address !== '' && (addressRegex instanceof Array && addressRegex.length > 0);
                }

                return false;
            },
            zipCodeValidated() {
                if (this.information.zipcode && String(this.information.zipcode).length === 4) {

                    var zipcodeRegex = String(this.information.zipcode).match(/^([0-9]){4,4}/gi);

                    return this.information.zipcode !== '' && (zipcodeRegex instanceof Array && zipcodeRegex.length > 0 && zipcodeRegex.length < 5);
                }

                return false;
            },
            cityValidated() {
                return this.information.city !== '' && this.information.city !== null;
            },
            emailValidated() {
                if (this.information.email) {
                    var emailRegex = this.information.email.match(/^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i);
                    return this.information.email !== '' && (emailRegex instanceof Array && emailRegex.length > 0);
                }

                return false;
            },
            phoneValidated() {
                if (this.information.phone) {
                    var phoneRegex = String(this.information.phone).match(/^([0-9]){8,8}/gi);

                    return this.information.phone !== '' && (phoneRegex instanceof Array && phoneRegex.length > 0);
                }
            },
            companyAndCvrValidated() {
                if (this.information.company_name && String(this.information.company_name).length > 0) {
                    return this.information.cvr !== '' && String(this.information.cvr).length === 8;
                }

                if (this.information.cvr &&String(this.information.cvr).length > 0) {
                    return this.information.company_name !== '' && String(this.information.company_name).length > 0 && String(this.information.cvr).length === 8;
                }

                return true;
            },
            eanValidated(){

                if(this.companyAndCvrValidated){
                    if(this.information.ean && String(this.information.ean).length > 0){
                        return String(this.information.ean).length > 6;
                    }

                    return true;
                }else{
                    return false;
                }
            },
            allInformationValidated() {
                return this.firstNameValidated
                    && this.lastNameValidated
                    && this.addressValidated
                    && this.zipCodeValidated
                    && this.cityValidated
                    && this.emailValidated
                    && this.phoneValidated
					&& this.companyAndCvrValidated
                    && this.eanValidated
            },
            hasEnteredFirstName() {
                return this.fieldHasBeenEntered('firstname');
            },
            hasEnteredLastName() {
                return this.fieldHasBeenEntered('lastname');
            },
            hasEnteredAddress() {
                return this.fieldHasBeenEntered('address');
            },
            hasEnteredZip() {
                return this.fieldHasBeenEntered('zip');
            },
            hasEnteredCity() {
                return this.fieldHasBeenEntered('city');
            },
            hasEnteredEmail() {
                return this.fieldHasBeenEntered('email');
            },
            hasEnteredPhone() {
                return this.fieldHasBeenEntered('phone');
            },
            hasEnteredCompanyName() {
                return this.fieldHasBeenEntered('company_name');
            },
            hasEnteredCvr() {
                return this.fieldHasBeenEntered('cvr');
            },
            hasEnteredEan() {
                return this.fieldHasBeenEntered('ean');
            },
		},
		methods:{
            fieldHasBeenEntered(fieldName) {
                return this.enteredFields.indexOf(fieldName) > -1
            },
            enteredField(fieldName) {
                if (!this.fieldHasBeenEntered(fieldName)) {
                    return this.enteredFields.push(fieldName);
                }
            },
            setAllFieldsAsEntered(){
              const fields = [
                  'firstname',
                  'lastname',
                  'address',
                  'zip',
                  'city',
                  'email',
                  'phone',
                  'company_name',
                  'cvr',
                  'ean',
              ];

              fields.forEach(field => this.enteredField(field));
            },
           /* updateInformationWithCity() {
                this.enteredField('city');
                if(this.city != this.information.city){
                    this.information.city = this.city;
                }
            },
			convertZipcodeToCity(){
				this.getCityForZipCode(this.information.zipcode).then(city => {
				    this.city= city;
				    this.information.city = city;
				}).catch(error => {
				    console.log(error);
				});
			},*/
            submitInformation() {
                this.setAllFieldsAsEntered();

                if (this.allInformationValidated) {
                    this.$store.dispatch('completedInformation');
                    this.$router.push({
                        name:'make-order.order.delivery'
                    });
                }
            },

		},
    }
</script>

<style scoped>

</style>
